/**
 * @generated SignedSource<<64d1919ec5c26901f33dca0a6826cd98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateEditFlight_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_package">;
  readonly " $fragmentType": "PackageDateEditFlight_package";
};
export type PackageDateEditFlight_package$key = {
  readonly " $data"?: PackageDateEditFlight_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditFlight_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateEditFlight_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "37807d1702b17a1d20f049b34a50c443";

export default node;
